<div id="kairos-main-layout">
  <div id="kairos-layout-nav">
    <kairos-nav-bar></kairos-nav-bar>
  </div>
  <div id="kairos-layout-content">
    <ng-content></ng-content>
  </div>
</div>
